var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeatlands = function SvgPeatlands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0.5,
    fill: "#FAA88C",
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M24.533 13.083c-1.566 3.025-2.758 6.225-3.316 9.584h-.759v-4.742a2.4 2.4 0 0 0 1.567-2.242v-4.375c0-1.025-.65-1.9-1.567-2.241v-.575a.836.836 0 0 0-.833-.834.836.836 0 0 0-.833.834v.575a2.4 2.4 0 0 0-1.567 2.241v4.375c0 1.025.65 1.9 1.567 2.242v4.742h-2.017c.183-1.192.392-2.375.733-3.525.125-.417-.15-.925-.583-1.025-.45-.1-.892.133-1.025.583-.383 1.3-.6 2.633-.8 3.975h-.892v-6.408a2.4 2.4 0 0 0 1.567-2.242V9.65c0-1.025-.65-1.9-1.567-2.242v-.575A.836.836 0 0 0 13.375 6a.836.836 0 0 0-.833.833v.575a2.4 2.4 0 0 0-1.567 2.242v4.375c0 1.025.65 1.9 1.567 2.242v6.408h-.759c-.558-3.358-1.75-6.558-3.316-9.583-.492-.95-1.934-.109-1.442.841 1.425 2.742 2.558 5.692 3.083 8.75H8.992a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h15a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834h-1.117c.525-3.058 1.667-6 3.083-8.75.492-.95-.941-1.791-1.441-.841l.016-.009ZM12.642 9.65a.734.734 0 0 1 1.466 0v4.375a.734.734 0 0 1-1.466 0V9.65Zm6.25 1.667a.734.734 0 0 1 1.466 0v4.375a.734.734 0 0 1-1.466 0v-4.375Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.5 6h20v20h-20z"
  })))));
};
export default SvgPeatlands;